import { render, staticRenderFns } from "./ExamsEdit.html?vue&type=template&id=61c4b3d2&external"
import script from "./ExamsEdit.ts?vue&type=script&lang=ts&external"
export * from "./ExamsEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./ExamsEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports